import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BoardStage } from '../../entities/board.entity';

@Component({
  selector: 'app-calendar-activity',
  templateUrl: './calendar-activity.component.html',
  styleUrl: './calendar-activity.component.scss'
})
export class CalendarActivityComponent {
  @Input() activity: any;
  @Input() types!: any[];
  @Input() searchTerm = '';
  @Input() showDate: boolean = false;
  @Input() truncAt: number = 75;
  @Input() fullSize: boolean = false;
  @Input() boardStage: BoardStage = BoardStage.DRAFT;
  BoardStage = BoardStage;

  isExpanded = false;
  @Output() onRemovePin: EventEmitter<any> = new EventEmitter();

  getTypeColor(type: any) {

    if (type)
      return this.types.find(t => t.value === type).color;

    return '#000000';
  }
  splitCamelCase(text: string): string {
    const result = text.replace(/([a-z])([A-Z])/g, '$1 $2');
    return result;
  }
  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }
  remove() {
    this.onRemovePin.emit(this.activity.activityID);
  }
}
